import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { InfoSection, type InfoSectionData } from '@/common/InfoSection';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import { HeaderWrapper } from '~/styles/layoutElements';

interface ProfilePageProps {
  title?: string;
  sections: InfoSectionData[];
  headerActions?: ReactNode;
}

export function ProfilePage({
  title,
  sections,
  headerActions,
}: ProfilePageProps) {
  const { t } = useTranslation();
  const pageTitle = title ?? t('profile.view-profile');

  return (
    <MainContent>
      <PageHeader>
        <TitleWithQuestion title={pageTitle} />
        {headerActions}
      </PageHeader>
      <InfoSection sections={sections} />
    </MainContent>
  );
}

const MainContent = styled.main`
  background: var(--color-background);
  flex: 1;
  min-width: 0;
  padding-top: 19px;
`;

const PageHeader = styled(HeaderWrapper)`
  margin-bottom: 30px;
`;
